import React from 'react'

const STATS=[
    {value: '100+', label: 'Projects supported'},
    {value: '500', label: 'People involved'},
    {value: '15', label: 'Events hosted'},
    {value: '20+', label: 'Partners'},
]

export default function StatsBar() {
    return (
        <section className='py-10 w-full border-y bg-dark border-dark-800'>
            <div className='grid grid-cols-2 gap-8 px-4 mx-auto max-w-5xl md:grid-cols-4'>
                {STATS.map(stat => (
                    <div key={stat.label} className='text-center'>
                        <div className='text-4xl font-bold text-light font-display lg:text-5xl'>{stat.value}</div>
                        <div className='mt-1 text-sm text-dark-300'>{stat.label}</div>
                    </div>
                ))}
            </div>
        </section>
    )
}
